import React, { PureComponent } from 'react'
import Header from 'components/header'
import Skip from 'components/skip'
import Copyright from 'components/copyright'
import { isDeviceMobile } from 'util/mobile'
import Banner from 'components/banner'
import withRouter from '../../hocs/with-router'

class MainWrapper extends PureComponent {
  componentDidUpdate(prevProps) {
    // New Relic is deprecated as of 12/10/20.  NR account expires 12/25/20
    // @TODO remove this code after 12/25/20

    // Check if New Relic is available and if the pathname has changed
    if (
      window.rg4js &&
      this.props.location &&
      prevProps.location &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      window.rg4js('trackEvent', {
        type: 'pageView',
        path: this.props.location.pathname,
      })
      // window.newrelic.setCurrentRouteName(location.pathname)
    }
  }

  render() {
    const isMobile = isDeviceMobile()
    const displayBanner = isMobile ? null : <Banner />
    const displayHeader = isMobile ? null : <Header />
    const containerClass = isMobile ? 'container--mobile' : 'container--desktop'
    const contentClass = isMobile ? 'content--mobile' : 'content--desktop'

    return (
      <div>
        <div>{displayBanner}</div>
        <div className={`container ${containerClass}`}>
          <div className={`content ${contentClass}`}>
            {displayHeader}
            <main role='main' className='content-wrapper clearfix'>
              <div className='content-wrapper--logo'>
                <a href='https://victorops.com/' target='_blank'>
                  <img
                    src='assets/splunk_on_call_badge.svg'
                    className='content-wrapper--logo--image'
                  />
                </a>
              </div>
              {this.props.children}
            </main>
            <Skip />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(MainWrapper)
